import {
    Collection,
    BaseCollections
} from './base';

Collection.Order = class Order extends Collection.Base {

    checkItem(item) {
        return super.checkItem(...arguments);
    }

    matchesParams(item) {
        if (this.params.start_date && item.created_at) {
            if (!this.start_date || !moment.isMoment(this.start_date)) {
                this.start_date = moment(this.params.start_date);
            }
            if (this.start_date.isAfter(item.created_at)) {
                return false;
            }
        }

        if (this.params.end_date && item.created_at) {
            if (!this.end_date || !moment.isMoment(this.end_date)) {
                this.end_date = moment(this.params.end_date);
            }
            if (this.end_date.isBefore(item.created_at.clone().startOf('day'))) {
                return false;
            }
        }

        if (!this.params.include_cancelled && item.is_cancelled) {
            return false;
        }

        return true;
    }
};

const OrderCollections = new BaseCollections();

export {
    OrderCollections
}
